(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.UNIFY_OPTIONS = factory();
})(typeof window === 'undefined' ? this : window, function () {
  'use strict';
  function resolve(variants, chosen) {
    var missing = chosen.indexOf(null);
    var variant = missing === -1 ? variants.find(function (v) {
      return chosen.every(function (value, i) { return v.options[i] === value; });
    }) || null : null;
    return { missing:missing, variant:variant, canBuy:!!(variant && variant.available) };
  }
  function available(variants, chosen, index, value) {
    var selection = chosen.slice(); selection[index] = value;
    return variants.some(function (v) {
      return v.available && selection.every(function (option, i) { return option === null || v.options[i] === option; });
    });
  }
  function initial(names,variants,color){
    var first=variants.find(function(v){return v.available;});
    return names.map(function(name,index){
      if(!/^colou?r$/i.test(name))return null;
      if(color&&variants.some(function(v){return v.options[index]===color;}))return color;
      return first?first.options[index]:null;
    });
  }
  function galleryIndex(positions,position){ return positions.indexOf(Number(position)); }
  return { resolve:resolve, available:available, initial:initial, galleryIndex:galleryIndex };
});
